import { Forecast } from '@domain/forecast/models/Forecast';
import { WeeklyForecast } from '@domain/forecast/models/WeeklyForecast';
import { WeeklyForecastComponent } from '@domain/forecast/models/WeeklyForecastComponent';
import { WeeklyForecastComponentType } from '@domain/forecast/enums/WeeklyForecastComponentType.enum';
import { ForecastDTO } from '../dto/ForecastDTO';
import { WeeklyForecastDTO } from '../dto/WeeklyForecastDTO';
import { WeeklyForecastComponentDTO } from '../dto/WeeklyForecastComponentDTO';
import { ForecastAnalytics } from '@domain/forecast/models/ForecastAnalytics';
import { ForecastAnalyticsDTO } from '../dto/ForecastAnalyticsDTO';
import { ForecastRunDTO } from '../dto/ForecastRunDTO';
import { ForecastRun } from '@domain/forecast/models/ForecastRun';
import { ForecastSourceType } from '@domain/forecast/models/Forecast';

export class ForecastMapper {
  static toModel(dto: ForecastDTO): Forecast {
    return {
      id: dto.id,
      date: new Date(dto.date),
      sourceType: dto.sourceType as ForecastSourceType,
      source: dto.source,
      connector: dto.connector,
      startDate: new Date(dto.startDate),
      endDate: new Date(dto.endDate),
      model: dto.model,
      parameters: dto.parameters,
      detectedParameters: dto.detectedParameters,
      weeklyForecasts: dto.weeklyForecasts?.map(WeeklyForecastMapper.toModel),
      weeklyForecastComponents: dto.weeklyForecastComponents?.map(WeeklyForecastComponentMapper.toModel),
      forecastAnalytics: dto.forecastAnalytics ? ForecastAnalyticsMapper.toModel(dto.forecastAnalytics) : undefined,
    };
  }
}

export class WeeklyForecastMapper {
  static toModel(dto: WeeklyForecastDTO): WeeklyForecast {
    return {
      forecastId: dto.forecastId,
      year: dto.year,
      week: dto.week,
      forecastQuantity: dto.forecastQuantity,
      forecastQuantityMin: dto.forecastQuantityMin,
      forecastQuantityMax: dto.forecastQuantityMax,
    };
  }
}

export class AggregatedWeeklyForecastMapper {
  static toModel(dto: Omit<WeeklyForecast, 'forecastId'>): Omit<WeeklyForecast, 'forecastId'> {
    return {
      year: dto.year,
      week: dto.week,
      forecastQuantity: dto.forecastQuantity,
      forecastQuantityMin: dto.forecastQuantityMin,
      forecastQuantityMax: dto.forecastQuantityMax,
    };
  }
}

export class WeeklyForecastComponentMapper {
  static toModel(dto: WeeklyForecastComponentDTO): WeeklyForecastComponent {
    return {
      forecastId: dto.forecastId,
      type: dto.type as WeeklyForecastComponentType,
      year: dto.year,
      week: dto.week,
      forecastQuantity: dto.forecastQuantity,
      forecastQuantityMin: dto.forecastQuantityMin,
      forecastQuantityMax: dto.forecastQuantityMax,
    };
  }
}

export class ForecastAnalyticsMapper {
  static toModel(dto: ForecastAnalyticsDTO): ForecastAnalytics {
    return {
      grade: dto.grade,
      grade_reasons: dto.grade_reasons,
      me: parseFloat(dto.me),
      mpe: parseFloat(dto.mpe),
      me_scaled: parseFloat(dto.me_scaled),
      rmse: parseFloat(dto.rmse),
      mse: parseFloat(dto.mse),
      mae: parseFloat(dto.mae),
      mape: parseFloat(dto.mape),
      mdape: parseFloat(dto.mdape),
      smape: parseFloat(dto.smape),
      coverage: parseFloat(dto.coverage),
      trend_influence: parseFloat(dto.trend_influence),
      seasonal_influence: parseFloat(dto.seasonal_influence),
      search_term_influence: parseFloat(dto.search_term_influence),
    };
  }
}

export class ForecastRunMapper {
  static toModel(dto: ForecastRunDTO): ForecastRun {
    return {
      id: dto.id,
      state_type: dto.state_type,
      state_name: dto.state_name,
    };
  }
}